module.exports = __webpack_public_path__ + "e219efaa3ef126b830dbb19f5be669d8.png";